import { useParams } from '@tanstack/react-router';

import { ErrorPage } from './page.error';
import CompareMapsPage, { MAP_DISPLAY_TYPES } from './pages/compare-maps/page';
import { SatelliteMap } from './pages/satellite-map/page';
import { YieldMap } from './pages/yield-map/page';
import YieldPotentialMap from './pages/yield-potential-map/page';

import { MAP_TYPES } from '@fields/data-access';

export const pagesMapping = {
  [MAP_TYPES.SATELLITE]: SatelliteMap,
  [MAP_TYPES.YIELD]: YieldMap,
  [MAP_TYPES.POTENTIAL]: YieldPotentialMap,
  [MAP_TYPES.COMPARE]: CompareMapsPage,
};

export function MapsPage() {
  const { mapType } = useParams({
    from: '/_app/fields_/$fieldId/maps/$mapType',
  });

  // @ts-expect-error - // TODO: Fix this
  const Page = pagesMapping[mapType];

  return <Page type={MAP_DISPLAY_TYPES.SINGLE} />;
}

MapsPage.Error = ErrorPage;

export default MapsPage;
